import styled from 'styled-components';

export const TrainingRegistrationLayout = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    column-gap: 20px;
    align-items: center;

    .without-label {
        width: 40%;
    }

    owc-switch {
        justify-content: center;
        width: 20%;
        margin-bottom: 20px;
    }
`;

export const TrainingRegistrationOptions = styled.div`
    position: absolute;
    top: 3px;
    right: -45px;
`;

export const TrainingRegistrationMappingWrapper = styled.div`
    > .loading-mask {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 100px 0;
    }

    > div:last-child:not(.loading-mask) {
        padding-bottom: 0;
    }

    owc-typography[variant='body1'] {
        color: var(--one-color-gray-600);
    }
`;
